module.exports = __webpack_public_path__ + "static/private75-logo-ae7350db5088b284201bc8092913deec.svg";